export default "<!-- my page -->"